import { useEffect, useState } from 'react'
import { useAuth } from '../state/auth'
import { api } from '../api/http'
import Modal from '../ui/Modal'
import Toast from '../ui/Toast'
import { useNavigate } from 'react-router-dom'
import './projects.css'

export default function Projects() {
    const navigate = useNavigate()
    const user = useAuth(s => s.user)
    const logout = useAuth(s => s.logout)
    const [projects, setProjects] = useState([])
    const [loading, setLoading] = useState(true)
    const [err, setErr] = useState(null)
    const [toast, setToast] = useState(null)
    const [openNew, setOpenNew] = useState(false)
    const [title, setTitle] = useState('')

    const load = async () => {
        setLoading(true)
        setErr(null)
        try {
            const data = await api('/projects/list')
            setProjects(data.projects || [])
        } catch (e) {
            setErr(e.message || 'Error')
            setToast('Failed to load projects')
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => { load() }, [])

    const create = async () => {
        if (!title.trim()) return
        try {
            const res = await api('/projects/create', { method: 'POST', body: JSON.stringify({ title: title.trim() }) })
            setProjects(p => [res.project, ...p])
            setOpenNew(false)
            setTitle('')
            setToast('Project created')
        } catch (e) {
            setToast(e.message || 'Create failed')
        }
    }

    return (
        <div className="projects-wrap">
            <header className="projects-header">
                <div className="left">{user?.admin == 1 ? <span style={{color: "red",marginRight: "10px"}}>[ADM]</span> : null}{user?.name || 'Projects'}</div>
                <div className="right">
                    <button className="btn" onClick={() => setOpenNew(true)}>New Project</button>
                    <button className="btn danger" onClick={logout}>Logout</button>
                </div>
            </header>

            <main className="projects-main">
                <div className="projects-title"><i className="fox-icon fox-icon-folders"></i> My Projects</div>
                {loading && <div className="muted">Loading…</div>}
                {err && <div className="error">{err}</div>}
                <div className="project-list">
                    {projects.map(p => (
                        <div
                            key={p.id}
                            className="project-card clickable"
                            onClick={() => navigate(`/projects/${p.id}`)}
                            tabIndex={0}
                            onKeyDown={e => { if (e.key === 'Enter') navigate(`/projects/${p.id}`) }}
                        >
                            <div className="title">{p.title}</div>
                            {p.created_at && <div className="meta">{new Date(p.created_at).toLocaleDateString()}</div>}
                        </div>
                    ))}
                    <div className="project-card new" onClick={() => setOpenNew(true)}>+ New Project</div>
                </div>
            </main>

            <Modal open={openNew} title="Create project" onClose={() => setOpenNew(false)} onSubmit={create} submitLabel="Create">
                <input placeholder="Project name" value={title} onChange={e => setTitle(e.target.value)} />
            </Modal>

            {toast && <Toast text={toast} onClose={() => setToast(null)} />}
        </div>
    )
}
